module.exports = __webpack_public_path__ + "romania.svg?edc6ec3b40fde370cfa3a82afb0fb9b4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/romania.svg
// module id = 275
// module chunks = 10